if (!customElements.get("fabric-cards")) {
    // Lista kart rodzin tkanin (Figma 110:1298).
    //
    // Karta to RODZINA ("Boucle Ando"), a konkretny odcien wybiera sie przez "Zmien"
    // na karcie zaznaczonej. Lista odcieni jest domyslnie zwinieta - bez tego krok
    // tkaniny byl dwiema listami jedna pod druga.
    class FabricCards extends HTMLElement {
        connectedCallback() {
            // Delegacja: karty sa przebudowywane po wybraniu rodziny premium, wiec
            // podpinanie sie do konkretnych przyciskow nie przetrwaloby podmiany.
            this.addEventListener("click", (event) => {
                const toggle = event.target.closest("[data-family-toggle]");

                if (!toggle) return;

                event.preventDefault();
                this.toggle(toggle);
            });

            // Wybor odcienia zamyka liste - karta pokazuje juz nowy kolor.
            //
            // Nasluchujemy KLIKNIECIA, nie tylko zdarzenia change: obsluga konfiguratora
            // wola preventDefault() na etykietach, wiec radio bywa zaznaczane recznie
            // i `change` sie nie odpala - lista zostawala otwarta po wybraniu odcienia.
            this.addEventListener("change", (event) => {
                if (!event.target.matches('input[type="radio"]')) return;

                const card = event.target.closest("[data-fabric-card]");

                if (card) this.close(card);
            });

            this.addEventListener("click", (event) => {
                const swatch = event.target.closest(".product-configurator__option--swatch");

                if (!swatch) return;

                const card = swatch.closest("[data-fabric-card]");

                // Zamykamy po tym, jak konfigurator przestawi zaznaczenie i pasek.
                if (card) setTimeout(() => this.close(card), 350);
            });

            // Liste odcieni otwiera i zamyka takze product-configurator (wybor
            // rodziny premium przebudowuje karte z lista juz rozwinieta), wiec
            // wyrownanie wiersza musi reagowac na kazda zmiane klas, nie tylko
            // na nasz wlasny toggle. Zmiany z syncRowAlign koncza sie po jednym
            // dodatkowym przebiegu - toggle bez roznicy nie emituje mutacji.
            this._rowWatch = new MutationObserver(() => this.syncRowAlign());
            this._rowWatch.observe(this, {
                attributes: true,
                attributeFilter: ["class"],
                subtree: true,
            });

            // Wyjscie z kroku tkanin zwija odcienie (decyzja Patryka 2026-09-03):
            // wracajac do kroku widzisz karty rodzin, a nie sciane swatchy po
            // poprzedniej wizycie. Dwa wyjscia licza sie tak samo:
            // - klik poza lista kart (inny krok, naglowek, pasek podsumowania),
            // - zjechanie krokiem tkanin z ekranu.
            this._onOutsideClick = (event) => {
                if (!this.contains(event.target)) this.closeOpen();
            };
            document.addEventListener("click", this._onOutsideClick);

            if ("IntersectionObserver" in window) {
                this._exitWatch = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (!entry.isIntersecting) this.closeOpen();
                        });
                    },
                    { threshold: 0 },
                );
                this._exitWatch.observe(this);
            }
        }

        disconnectedCallback() {
            if (this._rowWatch) this._rowWatch.disconnect();
            if (this._exitWatch) this._exitWatch.disconnect();
            if (this._onOutsideClick) {
                document.removeEventListener("click", this._onOutsideClick);
            }
        }

        list(card) {
            return card ? card.querySelector("[data-family-colors]") : null;
        }

        toggle(button) {
            const card = button.closest("[data-fabric-card]");
            const list = this.list(card);

            if (!list) return;

            if (!list.classList.contains("is-open")) {
                // Akordeon: otwarta jest najwyzej jedna lista odcieni (decyzja
                // Patryka 2026-09-03). Dwie naraz robily z kroku sciane swatchy
                // i kazdy otwarty wiersz musial wypadac z wyrownania.
                this.closeOpen(card);
                list.classList.add("is-open");
                button.setAttribute("aria-expanded", "true");
            } else {
                this.close(card);
                return;
            }

            this.syncRowAlign();
        }

        close(card) {
            const list = this.list(card);
            const button = card.querySelector("[data-family-toggle]");

            if (list) list.classList.remove("is-open");
            if (button) button.setAttribute("aria-expanded", "false");

            this.syncRowAlign();
        }

        // Zamyka otwarte listy odcieni; z argumentem oszczedza wskazana karte
        // (akordeon), bez argumentu zwija wszystko (wyjscie z kroku). Leci po
        // wszystkich kartach, nie tylko widocznych: schowana karta "Tkanina
        // bazowa" potrafi trzymac is-open z poprzednich klikniec.
        closeOpen(except) {
            this.querySelectorAll("[data-fabric-card]").forEach((card) => {
                if (card === except) return;

                const list = this.list(card);

                if (list && list.classList.contains("is-open")) this.close(card);
            });
        }

        // Otwarta lista odcieni podwyzsza track siatki, a `stretch` rozciagalby
        // do niej sasiadow. CSS nie wie, ktore karty leza w tym samym WIERSZU,
        // wiec oznaczamy je tutaj po wspolnej gornej krawedzi - tylko one dostaja
        // `align-self: start`, a pozostale wiersze zostaja rowne (stretch).
        // Itemami siatki sa i bezposrednie dzieci, i karty wyniesione przez
        // `display: contents` na fabric-family-list.
        syncRowAlign() {
            const grid = this.querySelector(".product-configurator__swatch-grid");
            if (!grid) return;

            const CARD =
                ".product-configurator__fabric-card, .product-configurator__option--fabric-family-card";

            // Realne kafle po klasach, nie po dzieciach grida: miedzy gridem
            // a kartami stoja kontenery z display:contents (step, lista rodzin),
            // a schowana karta "Tkanina bazowa" potrafi trzymac is-open z
            // poprzednich klikniec - stad filtr widocznosci i dopasowanie listy
            // do WLASNEJ karty przez closest.
            const cards = [...grid.querySelectorAll(CARD)].filter(
                (el) => el.getBoundingClientRect().height > 0,
            );

            // Otwartych list moze byc kilka naraz (kazda karta ma wlasny
            // przelacznik odcieni), wiec zbieramy WSZYSTKIE - `find` na pierwszej
            // zostawial sasiadki z pozostalych wierszy rozciagniete (zgloszenie
            // Patryka 2026-09-03: Truth i Pont otwarte, Morl krotki a Settle dlugi).
            const openCards = cards.filter((el) => {
                const list = el.querySelector("[data-family-colors].is-open");
                return list && list.closest(CARD) === el;
            });
            const openTops = openCards.map((el) => el.getBoundingClientRect().top);

            cards.forEach((el) => {
                const top = el.getBoundingClientRect().top;
                const mate =
                    !openCards.includes(el) &&
                    openTops.some((t) => Math.abs(top - t) < 2);
                el.classList.toggle("fabric-row-mate", !!mate);
            });
        }
    }

    customElements.define("fabric-cards", FabricCards);
}
